var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHogar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 128,
    viewBox: "0 0 135 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7188 100V96.302C27.7188 94.912 27.1639 93.574 26.1673 92.562C24.0568 90.418 20.2503 86.552 17.7127 83.976C16.0712 82.308 15.1562 80.104 15.1562 77.814C15.1562 70.382 15.1562 53.164 15.1562 43.996C15.1562 40.684 17.9661 38 21.4333 38H21.4417C23.1062 38 24.7037 38.632 25.8804 39.756C27.0571 40.88 27.7188 42.406 27.7188 43.996C27.7188 48.538 27.7188 54 27.7188 54",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.281 100V96.302C107.281 94.912 107.836 93.574 108.833 92.562C110.943 90.418 114.75 86.552 117.287 83.976C118.929 82.308 119.844 80.104 119.844 77.814C119.844 70.382 119.844 53.164 119.844 43.996C119.844 40.684 117.034 38 113.567 38H113.558C111.894 38 110.296 38.632 109.12 39.756C107.943 40.88 107.281 42.406 107.281 43.996C107.281 48.538 107.281 54 107.281 54",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2188 112.758V102.892C61.2188 102.126 60.9005 101.39 60.331 100.848C59.7636 100.304 58.9931 100 58.1912 100C51.4703 100 35.3735 100 28.6526 100C27.8507 100 27.0802 100.304 26.5127 100.848C25.9432 101.39 25.625 102.126 25.625 102.892C25.625 106.656 25.625 112.758 25.625 112.758",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7812 112.758V102.892C73.7812 102.126 74.0995 101.39 74.669 100.848C75.2364 100.304 76.0069 100 76.8088 100C83.5297 100 99.6265 100 106.347 100C107.149 100 107.92 100.304 108.487 100.848C109.057 101.39 109.375 102.126 109.375 102.892C109.375 106.656 109.375 112.758 109.375 112.758",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.125 100V89.018C59.125 84.14 57.0312 79.476 53.3316 76.112C48.5432 71.758 41.8662 65.688 37.6494 61.852C35.4174 59.824 31.902 59.866 29.7245 61.946L29.7204 61.95C27.4591 64.11 27.4591 67.614 29.7204 69.774C33.7152 73.592 39.1988 78.828 39.1988 78.828",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.875 100V89.018C75.875 84.14 77.9687 79.476 81.6684 76.112C86.4568 71.758 93.1338 65.688 97.3506 61.852C99.5825 59.824 103.098 59.866 105.275 61.946L105.28 61.95C107.541 64.11 107.541 67.614 105.28 69.774C101.285 73.592 95.8012 78.828 95.8012 78.828",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.75 25V46C50.75 47.06 51.1918 48.078 51.9769 48.828C52.7621 49.578 53.8278 50 54.9375 50C61.3737 50 73.6263 50 80.0625 50C81.1722 50 82.2379 49.578 83.0231 48.828C83.8082 48.078 84.25 47.06 84.25 46C84.25 38.938 84.25 25 84.25 25",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4688 26L67.5 16L90.5312 26",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6875 50V42C71.6875 39.79 69.8136 38 67.5 38C65.1864 38 63.3125 39.79 63.3125 42C63.3125 45.49 63.3125 50 63.3125 50",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4062 24C65.4062 24 61.5914 25.822 59.1103 27.006C57.8373 27.616 57.0312 28.86 57.0312 30.222C57.0312 31.142 57.0312 32 57.0312 32",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHogar);
export default __webpack_public_path__ + "static/media/hogar.2ccb2a642a1483f11c58054b86f6cedd.svg";
export { ForwardRef as ReactComponent };